// Definición de defaults

export const defaultTipoAmparo: TipoAmparoProps = {
    idTipoAmparo:   0,
    descripcion:    '',
    activo:         false,
}

// Creación de interfaces

export interface TipoAmparoProps {
    idTipoAmparo:   number;
    descripcion:    string;
    activo:         boolean;
}